/**
 * Section Visibility System
 *
 * - Handles visibility based on URL parameters only.
 * - Device visibility is handled in Liquid via CSS classes
 *   (.small-hide, .medium-hide, .large-up-hide).
 * - Does not run in the theme editor (design mode).
 */
document.addEventListener('DOMContentLoaded', () => {
  if (window.Shopify && window.Shopify.designMode) return;

  const urlParams = new URLSearchParams(window.location.search);

  document.querySelectorAll('[data-section-visibility]').forEach(el => {
    const raw = el.getAttribute('data-section-visibility');
    if (!raw) return;

    try {
      const config = JSON.parse(raw);
      const { urlParam, urlEnabled, customValueEnabled, customValues } = config;

      // Only check URL parameter if conditional visibility is enabled
      if (urlEnabled === true && urlParam) {
        const value = (urlParams.get(urlParam) || '').toLowerCase().trim();

        let shouldShow = false;

        // Check if custom values are enabled
        if (customValueEnabled === true && customValues) {
          // Split by semicolon, clean up spaces and empty values
          const allowedValues = customValues
            .split(';')
            .map(v => v.trim().toLowerCase())
            .filter(v => v.length > 0);

          // Show section if URL param value matches any allowed value
          shouldShow = allowedValues.includes(value);
        } else {
          // Default behavior: show only if ?param=1 or ?param=true
          shouldShow = (value === '1' || value === 'true');
        }

        if (shouldShow) {
          // Remove hidden class to show section (was hidden by Liquid initially)
          el.classList.remove('section-visibility-hidden');
        } else {
          // Add hidden class if parameter is not present or doesn't match
          el.classList.add('section-visibility-hidden');
        }
      }
    } catch (e) {
      // Fail silently to avoid breaking the page
      console.error('Section visibility error:', e, 'for element:', el);
    }
  });
});